'use client';

import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { type ReactElement } from 'react';
import { Button, type Key, Label, Tag, TagGroup, type TagGroupProps, TagList, type TagListProps, Text } from 'react-aria-components';
import { Alert } from '../alert/alert';
import { AlertVariant } from '../alert/alertVariant';
import { CloseIcon } from '../svgs';
import styles from './tags-list.module.scss';
export type TagsListProps<T> = Omit<TagGroupProps, 'children'> & Pick<TagListProps<T>, 'children' | 'items'> & {
  additionalContentSlot?: ReactElement;
  centerContent?: boolean;
  description?: string;
  errorMessage?: string;
  items: TagItem[];
  label?: null | string;
  onRemove?: (keys: Set<Key>) => void;
};
type TagItem = {
  id: number | string;
  name: string;
  url?: string;
};
export const TagsList = t0 => {
  const $ = _c(33);
  let additionalContentSlot;
  let description;
  let errorMessage;
  let items;
  let label;
  let onRemove;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      additionalContentSlot,
      centerContent: t1,
      description,
      errorMessage,
      items,
      label,
      onRemove,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = additionalContentSlot;
    $[2] = description;
    $[3] = errorMessage;
    $[4] = items;
    $[5] = label;
    $[6] = onRemove;
    $[7] = rest;
    $[8] = t1;
  } else {
    additionalContentSlot = $[1];
    description = $[2];
    errorMessage = $[3];
    items = $[4];
    label = $[5];
    onRemove = $[6];
    rest = $[7];
    t1 = $[8];
  }
  const centerContent = t1 === undefined ? false : t1;
  let t2;
  if ($[9] !== centerContent) {
    t2 = classNames(styles.tags, {
      [styles["tags--center-content"]]: centerContent
    });
    $[9] = centerContent;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== onRemove) {
    t3 = onRemove ? {
      onRemove: keys => onRemove(keys)
    } : {};
    $[11] = onRemove;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== label) {
    t4 = label && <Label className={styles.tags__label} elementType="h2">{label}</Label>;
    $[13] = label;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== description) {
    t5 = description && <Text className={styles.tags__description} elementType="p" slot="description">{description}</Text>;
    $[15] = description;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== errorMessage) {
    t6 = errorMessage && <Alert className={styles["tags__error-message"]} message={errorMessage} variant={AlertVariant.Error} />;
    $[17] = errorMessage;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== items || $[20] !== onRemove) {
    t7 = items.length > 0 && <TagList>{items.map(item => <Tag className={_temp} id={item.id} key={item.id} textValue={item.name}><>{item.name}{onRemove && <Button className={styles["tag__icon-container"]} data-testid="tag-remove-button" slot="remove"><CloseIcon /></Button>}</></Tag>)}</TagList>;
    $[19] = items;
    $[20] = onRemove;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== additionalContentSlot || $[23] !== t7) {
    t8 = <div className={styles.tags__list}>{t7}{additionalContentSlot}</div>;
    $[22] = additionalContentSlot;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== rest || $[26] !== t2 || $[27] !== t3 || $[28] !== t4 || $[29] !== t5 || $[30] !== t6 || $[31] !== t8) {
    t9 = <TagGroup className={t2} {...t3} {...rest}>{t4}{t5}{t6}{t8}</TagGroup>;
    $[25] = rest;
    $[26] = t2;
    $[27] = t3;
    $[28] = t4;
    $[29] = t5;
    $[30] = t6;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  return t9;
};
function _temp(t0) {
  const {
    isSelected
  } = t0;
  return classNames(styles.tag, styles["tag--interactive"], {
    [styles["tag--theme-active"]]: isSelected,
    [styles["tag--theme-light"]]: !isSelected
  });
}